// The one-time line after bookmarking: every bookmarked session sends its own reminder (push and in-app notification,
// once, when it starts within 15 minutes: wad-api NotificationService::generateAndSendAutomatedNotifications), and
// nothing else in the app says so. Shown once per device (localStorage), and at most once per visit where storage is
// blocked. The 15 is the server's number, keep the two together.
const STORAGE_KEY = 'wad4-reminder-hint-seen';

export const useReminderHint = () => {
  const visible = useState<boolean>('wad4-reminder-hint-visible', () => false);
  const shownThisVisit = useState<boolean>('wad4-reminder-hint-shown', () => false);

  const announce = () => {
    if(shownThisVisit.value) {
      return;
    }
    try {
      if(localStorage.getItem(STORAGE_KEY) === '1') {
        return;
      }
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // Storage blocked: shownThisVisit is all there is.
    }
    shownThisVisit.value = true;
    visible.value = true;
  };
  const dismiss = () => {
    visible.value = false;
  };

  return {visible, announce, dismiss};
};
